import { render, staticRenderFns } from "./startPage.vue?vue&type=template&id=2db36f56&scoped=true&"
import script from "./startPage.vue?vue&type=script&lang=js&"
export * from "./startPage.vue?vue&type=script&lang=js&"
import style0 from "./startPage.vue?vue&type=style&index=0&id=2db36f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db36f56",
  null
  
)

export default component.exports